import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {Helmet} from 'react-helmet';
import ReactTable from "react-table";
import cellHeaderHOC from '../../components/common/Datagrid/CellHeaderHOC';
import { sessionStore } from '../../helpers/SessionStore';
import { connect } from 'react-redux';
import { debounce, find, findIndex, isEqual } from 'lodash';
import { withRouter } from 'react-router';
import { convertToThousands } from '../../helpers/NumberFormatter';

import CSV from '../../helpers/CSVExport';
import LoadingMessage from '../../helpers/LoadingMessage';
import Box from '../../components/common/Box';
import FieldSelector from '../../components/common/Datagrid/FieldsSelector';
import PageFilter from '../../components/common/Datagrid/PageFilter';
import SectionHeader from '../../components/common/Datagrid/SectionHeader';
import PlaylistSearchForm from '../../components/forms/playlistSearch';
import EntityCard from '../../components/common/EntityCard';
import EntityFilters from '../../components/common/EntityFilters';
import TerritoryStats from '../../components/common/Stats/Territory';
import PlaylistDistribution from '../../components/pages/playlists/Distribution';
import PlaylistTracks from '../../components/pages/playlists/PlaylistTracks';
import SearchWidget from '../../components/pages/home/SearchWidget';
import ScrollButtons from '../../components/common/ScrollButtons';

import { playlistsActions } from '../../data/actions/playlists';
import { playlistsFormatter } from '../../data/formatters/playlists'
import { playlistsSettings } from '../../components/pages/playlists/Settings'
import { filterActions } from '../../data/actions/filter';

const CellHeaderTable = cellHeaderHOC(ReactTable);
var barSvg = require('!svg-inline-loader!../../../public/img/chart-bar.svg');
var tableSvg = require('!svg-inline-loader!../../../public/img/table.svg');
var worldSvg = require('!svg-inline-loader!../../../public/img/world.svg');
var manageSvg = require('!svg-inline-loader!../../../public/img/manage.svg');
var downloadSvg = require('!svg-inline-loader!../../../public/img/download.svg');

class PlaylistSearch extends Component {
    
    defaultPageSize = 10;

    defaultOptions = {
        'playlist_name': '',
//        'tags':'',
        'atspd':false,
        'current_tracks':false,
        'playlist_source': false,
        'playlist_types': [],
        'ages':false,
        'genders':false
    }; 

    constructor(props) {
        super(props)
        this.state = {
            data: [],
            pages: -1,
            total: 0,
            page: 0,
            //pageSize: 10,
            filtered: '',
            filter: { // will be set from FieldsSelector
                columns: this.getInitialColumns(),
                filtered: this.getInitialFilter()
            },
            defaultSorted: [{id: 'curr_units', desc: true}],
            view: 'table',
            currentFilter: null
        }
        this.getInitialFilter = this.getInitialFilter.bind(this);
        this.getPageFilter = this.getPageFilter.bind(this);
        this.setFilter = this.setFilter.bind(this);
        this.setSearch = this.setSearch.bind(this);
        this.loadData = this.loadData.bind(this);
        this.setFilterSearch = this.setFilterSearch.bind(this);
        this.setFilterForm = this.setFilterForm.bind(this);
        this.setFilterSearchDeb = debounce(this.setFilterSearch, 1000);
        this.dispatchLoadData = this.dispatchLoadData.bind(this);
        this.addToPlaylistsFilter = this.addToPlaylistsFilter.bind(this);
        this.exportToCsv = this.exportToCsv.bind(this);
        this.searchResult = this.searchResult.bind(this);
        this.resetSearchResult = this.resetSearchResult.bind(this);
        this.applyFilter = this.applyFilter.bind(this);
        this.resetFilter = this.resetFilter.bind(this);
        // this.tableScrollTop = 0;
    }
    
    componentDidMount() {
        //this.dispatchLoadData(this.state);
        const cellHeaderTable = ReactDOM.findDOMNode(this.refs.CellHeaderTable);
        const tableContainer = cellHeaderTable.getElementsByClassName('rt-table')[0];
        this.setState({
            tableContainer
        });

        if (this.props.hasResizeAdjustment && window.ResizeObserver) {
            const resizeObserver = new ResizeObserver((entries) => {
                this.setState({
                    hasHorizontalScroll: tableContainer.scrollWidth > tableContainer.clientWidth
                });
            });
            this.setState({
                resizeObserver
            });
        
            resizeObserver.observe(tableContainer);
        } else {
            console.log("Resize observer not supported!");
            this.setState({
                hasHorizontalScroll: tableContainer.scrollWidth > tableContainer.clientWidth
            });
        }
    }
  
    loadData(state, instance) {
        this.setState({
            sorted: state.sorted
        }, ()=>this.dispatchLoadData(state));
    }
  
    getDefaultOptions() {
        const savedOptions = sessionStore.get('PlaylistSearchForm');
        return savedOptions || this.defaultOptions;
    }
    
    getInitialColumns() {
        return playlistsSettings.settingsForTable()
            .filter(item=>(item.show===undefined || item.show===true))
            .map(item=>item.id);
    }
    
    exportToCsv(){
        const sorted = this.state.sorted[0];
        const filename = CSV.CSVHeader('playlists', sorted.id, this.props.filter.global);
        let { data } = this.state;
        /*
        for(let item of data) {
            let tags = {};
            if(item.pl_tags) {
                for(let tag of item.pl_tags) {
                    const category = tag.tag_category;
                    if(!tags.hasOwnProperty(category)) {
                        tags[category] = [tag.tag]
                    }
                    else {
                        tags[category].push(tag.tag);
                    }
                }
            }
            item.tags = JSON.stringify(tags);
        }
        */
        return CSV.CSVExport(data, {filename}, 'playlists_search');
    }
    
    getPageSize() {
        return this.props.filter.global ? this.props.filter.global.limit : this.defaultPageSize;
    }
    
    getInitialFilter() {
        let filter = [],
            options = Object.assign({}, this.getDefaultOptions()),
            { params } = this.props.match;
        
        if(params.entity_type && params.entity_id){
            options[params.entity_type] = params.entity_id;
        }
        for(let option in options) {
            filter.push({
                id: option,
                value: options[option]
            });
        }
        return filter;
    }

    dispatchLoadData(state){
        const { dispatch } = this.props;
        dispatch(playlistsActions.getPlaylists({
            page: state.page,
            //pageSize: state.pageSize,
            sorted: state.sorted,
            filtered: state.filtered
        }));      
    }
    
    getPageFilter(props, entity){
        let ids = [];
        if(props.filter[entity])
            ids = props.filter[entity].map(item=>item.id);
        return ids;
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.playlists && nextProps.playlists.items){
            this.setState({
                data: nextProps.playlists.items,
                pages: Math.ceil(nextProps.playlists.total / this.getPageSize()),
                total: nextProps.playlists.total
            })
        }
        if(nextProps.filter){
            if(nextProps.filter.global){
                if(this.props.filter.global!==undefined && !isEqual(nextProps.filter.global, this.props.filter.global)) {
                    let state = Object.assign({}, this.state);
                    state.filtered = state.filter.filtered;
                    this.dispatchLoadData(state);
                }                
                /*
                this.setState({
                    pageSize: nextProps.filter.global.limit
                });
                */
            }
        }

    }
      
    setFilter(filter){
        this.setState({
            filter
        })
    }
    
    setFilterSearch(value, id){
        let filtered = this.state.filter.filtered.slice(0),
            valueIndex = findIndex(filtered, {id});
    
        if(valueIndex!==-1){
            filtered[valueIndex] = {id, value};
        }
        else {
            filtered.push({id, value})
        }
    
        this.setState({
            ...this.state,
            filter: {
                ...this.state.filter,
                filtered
            }
        });      
    }
  
    setSearch(e){
        const value = e.target.value;
        this.setState({
            filtered: value
        })
        this.setFilterSearch(value, 'artist')      
    }

    renderToolbar(){
        let toolbar = [];

        toolbar.push(
            <div className="playlist-library-tools-item">
                {this.state.view == 'table' && this.state.total !=0 && <p className="playlist-library-streams">{convertToThousands(this.state.total)} Playlist Streams</p>}
                <div className="manage-columns-holder">
                    <a key="settings" className="dropdown-toggle manage-columns-title" data-toggle="dropdown" href="#">
                        Manage Columns
                        <span className="chart-icon" dangerouslySetInnerHTML={{__html: manageSvg}}></span>
                    </a>
                    <div key="settings-box" className="dropdown-menu">
                        <FieldSelector settings={playlistsSettings.settingsForTable()} current={this.state.filter} onUpdate={this.setFilter} />                
                    </div>
                </div>          
            </div>,
            <div className="playlist-library-tools-item">
                <a key="table" title="Table" className={"chart-icon " + (this.state.view == 'table' ? 'active' : '')} 
                onClick={()=>this.setView('table')}
                dangerouslySetInnerHTML={{__html: tableSvg}}>
                </a>
                <a key="chart" title="Bar Chart" className={"chart-icon " + (this.state.view == 'chart' ? 'active' : '')} 
                    onClick={()=>this.setView('chart')}
                    dangerouslySetInnerHTML={{__html: barSvg}}>
                </a>
                <a key="map" title="Map" className={"chart-icon " + (this.state.view == 'map' ? 'active' : '') } 
                    onClick={()=>this.setView('map')}
                    dangerouslySetInnerHTML={{__html: worldSvg}}>
                </a>
                <a key="download" title="Export CSV" onClick={this.exportToCsv} className="chart-icon download-link" 
                    dangerouslySetInnerHTML={{__html: downloadSvg}} />
                <div>
                    {this.state.view == 'table' && this.state.hasHorizontalScroll && <ScrollButtons el={this.state.tableContainer} />}
                </div>
            </div>
        );
        
        return toolbar;
    }

    setView(view){
        this.setState({
            view
        })
    }
    
    addToPlaylistsFilter(playlist){
    }
    
    setFilterForm(formData) {
        let filtered = [];
        
        for(let id of Object.keys(formData)) {
            let value = formData[id];
            filtered.push({id, value});
        }
        
        this.setState({
            ...this.state,
            filter: {
                ...this.state.filter,
                filtered
            }
        });
        
        sessionStore.set('PlaylistSearchForm', formData);
    }
    
    searchResult(item) {
        let filter = [],
            options = Object.assign({}, this.getDefaultOptions());
        if(item.entity == 'artists')
            item.entity = 'track_artists';
        
        options[item.entity] = item.id;

        for(let option in options) {
            filter.push({
                id: option,
                value: options[option]
            });
        }
        this.setState({
            ...this.state,
            filter: {
                ...this.state.filter,
                filtered: filter
            }
        }, ()=> {
            this.props.history.push(`/playlists/${item.entity}/${item.id}`);
        });
    }
    
    applyFilter(filter) {
        this.setState({currentFilter: filter}, ()=>this.searchResult(filter));
    }
    
    resetFilter() {
        this.setState({currentFilter: null}, ()=>this.props.history.push(`/playlists/`));
    }


    resetSearchResult(item) {
        let filter = [],
            options = Object.assign({}, this.getDefaultOptions());
        
        for(let option in options) {
            filter.push({
                id: option,
                value: options[option]
            });
        }
        this.setState({
            ...this.state,
            filter: {
                ...this.state.filter,
                filtered: filter
            }
        }, ()=> {
            this.props.history.push(`/playlists`);
        });
    }

    componentWillUnmount() {
        const cellHeaderTable = ReactDOM.findDOMNode(this.refs.CellHeaderTable);
        const tableContainer = cellHeaderTable.getElementsByClassName('rt-table')[0];

        this.state.resizeObserver && this.state.resizeObserver.unobserve(tableContainer)
    }

    render() {
        const tableData = this.state.data,
            total = this.state.total, 
            { params } = this.props.match,
            { currentFilter } = this.state,
            isFiltered = params.entity_type && params.entity_id;
            
        return (
            <div className="wrapper wrapper-content light-blue-bg no-padding wrapper-mt">
                <Box title="" title="Playlist Overview" className="light-blue-bg">
                    {!currentFilter && <div className="column ibox-content section-header top-header playlist-search-container">
                        {isFiltered && <div>
                            <EntityCard entity={params.entity_type} id={params.entity_id} reset={this.resetSearchResult} />
                        </div>}   
                        {!isFiltered && <SearchWidget searchResult={this.searchResult} placeholder="Search playlists by imprint, artist, product or track" mode="playlist" /> }
                        
                    </div>}
                    <div className="column ibox-content section-header top-header">
                        <EntityFilters currentFilter={this.state.currentFilter} onSelect={this.applyFilter} onReset={this.resetFilter} />
                    </div>
                    <div className="column ibox-content section-header">
                        <PlaylistSearchForm  onSubmit={this.setFilterForm} values={this.state.filter.filtered} />
                    </div>
                    {/*
                        <SectionHeader entity="playlists" label="Playlists" data={this.state.data} filtered={this.state.filtered} onChange={this.setSearch}>
                            <PageFilter mode="current" entity="playlists" label="Playlists" />
                            <PageFilter mode="parent" entity="imprints" label="Imprints" />
                        </SectionHeader>
                    */}
                    <div className="ibox-tools playlist-tools playlist-library-tools-holder">{this.renderToolbar()}</div>
                    {this.state.view == 'table' && <div>
                        <CellHeaderTable
                            ref="CellHeaderTable"
                            showScrollBtn={false}
                            hasResizeAdjustment={false}
                            loading={this.props.playlists.loading}
                            loadingText={LoadingMessage('playlist')}
                            manual
                            className="playlist-table catalogue-table-holder playlist-table--search"  
                            resizable={false}
                            data={tableData}
                            pages={this.state.pages}          
                            showPageSizeOptions={false}
                            defaultPageSize={this.getPageSize()}
                            columns={playlistsSettings.settingsForTable(this.state.filter.columns, this.addToPlaylistsFilter)}
                            defaultSorted={this.state.defaultSorted}
                            filtered={this.state.filter.filtered}
                            onFetchData={this.loadData}
                            defaultSortDesc={true}
                            SubComponent={row => <PlaylistTracks 
                                playlistID={row.original.id} 
                                parentEntity={params.entity_type}
                                parentEntityID={params.entity_id}
                                mode="expanded" 
                            />} 
                        /> 
                    </div>}
                    {this.state.view == 'chart' && <div className="homepage">
                        <div className="default distribution-chart">
                            <PlaylistDistribution data={tableData} />   
                        </div>
                    {/*<LineChart */}
                    </div>}
                    {this.state.view == 'map' && <div className="map-holder homepage territory-stats-holder">
                        <TerritoryStats entity="playlists" expanded={true} ids={tableData.map(entry=>entry.playlist_id)}/>   
                    </div>}
                </Box>
                <Helmet>
                    <title>Playlist Library</title>
                </Helmet>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        playlists: state.playlists,
        filter: state.filter
    } 
}

export default withRouter(connect(mapStateToProps)(PlaylistSearch))